import { type EventForMasterFile } from '@bluebrick/discounts-service-module'
import { toBase64 } from '@/common/utils'
import { useApi } from '@/features/api/useAPI'
import { useTelemetry } from '@/features/telemetry/useTelemetry'
import { type SkuDataWithAccountName } from '@/types'

export async function submitEventsForSetters(skuData: SkuDataWithAccountName[]): Promise<EventForMasterFile[] | undefined> {
	const { trackException } = useTelemetry()
	const { apiPost } = useApi()

	try {
		const { data } = await apiPost<EventForMasterFile[]>(
			`/events/setters/submit`,
			{
				skuData: toBase64(JSON.stringify(skuData))
			},
			{ fetchOptions: { canRetry: true } }
		)

		return data
	} catch (e) {
		trackException(e as Error, `Failed to submit events to setters.`)

		throw e
	}
}
